import React, { useState, useEffect, useRef } from "react";
import { Container, Grid, TextField,
    InputAdornment,
    IconButton,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box,
    Popover,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import SearchIcon from "@mui/icons-material/Search";
import { useAppSelector } from "../../redux/hooks";
import { LIST_LIMIT } from "../../constants/constants";
import Pagination from "../common/Pagination";
import CommonButton from "../common/Button";
import lazyTypingUtils from "../../utils/lazyTypingUtils";
import HeaderTitle from "../common/HeaderTitle";
import ProductVariationApi from "./services/productVariationService";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router";
import FaceProductAccordion from "./FaceProductAccordion";
import {ProductVariationType, ProductVariationWithPaginationType, VariationDetailsItem, VariationDetailsItemType } from "../../interfaces/productVariationInterface";
import NonFaceProducts from "./NonFaceProducts";
import { ROUTES } from "../../constants/routes";
import Skeleton from "../common/Skeleton";
import CloseIcon from "@mui/icons-material/Close";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import { SearchIconButton } from "../../utils/searchUtils";

const ProductVariationList = (props:any) => {
    const node = useRef<HTMLDivElement>(null);
    const firstPage = 1;
    const perPageLimit = useAppSelector((state) => state.common.perPageLimit);
    const [limit, setLimit] = useState(!perPageLimit ? LIST_LIMIT.PAGINATION_LIST_LIMIT : perPageLimit );
    const [currentPage, setCurrentPage] = useState(firstPage);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [search, setSearch] = useState<string>("");
    const [skeleton, setSkeleton] = useState(true);
    const [nonFaceProductSkeletonS, setNonFaceProductSkeletonS] = useState<any>({});
    const [variationData, setVariationData] = useState <ProductVariationType[]>([]);
    const [variationDetailData, setVariationDetailData] = useState <VariationDetailsItem[]>([]);
    const [isSearchChange,setIsSearchChange]=useState<boolean>(false);
    const [expandedIndex, setExpandedIndex] = useState<number | false>(false);
    const [direction,setDirection]=useState<string>("desc");
    const [selectedColumn,setSelectedColumn]=useState<string>("");
    const [colFilter,setColFilter] =useState<string>("");
    const [anchorElPopover, setAnchorElPopover] = React.useState<HTMLButtonElement | null>(null);
    const isDemoUser = useAppSelector((state) => state.common.demoUser) ?? false;
    
    
    const { showSnackbar } = props;
    const navigate = useNavigate();
    const { t } = useTranslation();
   
    const handleAccordionChange = (panelIndex: number,groupId:number) => (
        event: React.SyntheticEvent,
        isExpanded: boolean
    ) => {
        setExpandedIndex(isExpanded ? panelIndex : false);
        setNonFaceProductSkeletonS((prevState:any)=>({
            ...prevState,
            [groupId]:true
        }));
    };

    const handleSorting =(changedColumn:any)=>{
        if(selectedColumn!=changedColumn){
            setDirection("asc");
        }else{
            setDirection(direction=="asc"? "desc":"asc");
        }           
        setSelectedColumn(changedColumn);
        setColFilter(changedColumn);
    };
    useEffect(() => {
        productVariationListApi(firstPage, limit ,);        
    }, [colFilter,direction]);

    const productVariationListApi = (currentPage:number, limit:number) => {
        setExpandedIndex(false);
        setIsSearchChange(true);
        setSkeleton(true);
        const payload = {};
        const isHitDummyURL = false;
        new ProductVariationApi(payload, isHitDummyURL)
            .productVariationListData(currentPage, search, limit,direction,colFilter)
            .then((res:ProductVariationWithPaginationType) => {
                setLimit(limit);
                setCurrentPage(currentPage);
                setTotalCount(res?.pagination?.totalCount);
                setTotalPages(res?.pagination?.totalPages);
                setVariationData(res?.productVariationLogs);

                res.productVariationLogs?.map((item) => {
                    setNonFaceProductSkeletonS((prevState:any) => ({
                        ...prevState,
                        [item?.variationGroupId]: true,
                    }));
                });
                setSkeleton(false);
            })
            .catch((err:any) => {
                showSnackbar(err?.message, false);
                setSkeleton(false);
            }); 
    };
    const variationDetailsApi = (variationGroupId:number) => {
        // setSkeleton(true);
        setIsSearchChange(true);
        const payload = {};
        const isHitDummyURL = false;
        new ProductVariationApi(payload, isHitDummyURL)
            .variationDetails(variationGroupId)
            .then((res:VariationDetailsItemType) => {
                setLimit(limit);
                setVariationDetailData(res?.variationDetailsLogs);
                setNonFaceProductSkeletonS((prevState:any)=>({
                    ...prevState,
                    [variationGroupId]:false
                }));
            })
            .catch((err:any) => {
                showSnackbar(err?.message, false);
                setNonFaceProductSkeletonS((prevState:any)=>({
                    ...prevState,
                    [variationGroupId]:false
                }));
            }); 
    };
    const navigateToAddVariation = () => {
        navigate(ROUTES.MANAGE_VARIATION);
    };
  
    const handleSearchChange = (e: any) => {
        setIsSearchChange(true);
        const { value } = e.target;
        setSearch(value);
        setSkeleton(true);
        setExpandedIndex(false);
    };
    const onsearchApicall = () =>{
        if(isSearchChange){
            productVariationListApi(firstPage, limit);
        } 
    };

    const propItem = [
        onsearchApicall,search
    ];
    lazyTypingUtils(propItem);

    // const handleKeyPress = (e: any) => {
    //     if (e.keyCode == 13) {
    //         // categoryData(currentPage,1);
    //     }
    // };
    const showVariationDetails=(variationGroupId: number, index:number)=>{
        if (variationGroupId !== undefined && index !== expandedIndex) {
            variationDetailsApi(variationGroupId);
        }
    };
    const filterVariationDetails = (variationDetailData:VariationDetailsItem[],faceProduct:ProductVariationType)=>{
        return variationDetailData.filter((item) => item?.cainzProductCode!== faceProduct?.cainzProductCode);
    };
    /**
    *
    * @description - Function to open instruction popover in product list
    */ 
    const handleInsPopoverOpen = (event: any) => {
        setAnchorElPopover(event.currentTarget);
    };

    /**
    *
    * @description - Function to close instruction popover in product list
    */  
    const handleInsPopoverClose = () => {
        setAnchorElPopover(null);
    };
    return (
        <>

            <Popover
                open={Boolean(anchorElPopover)}
                anchorEl={anchorElPopover}
                onClose={handleInsPopoverClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                className="instruction_popover">
                {  isDemoUser ? 
                    <Box className="instruction_popover_box">
                        <Typography sx={{pb:2}}>{t("product_variation_list.demo_product_variation_instruction_no_1")}</Typography>
                    </Box> : 
                    <Box className="instruction_popover_box">
                        <Typography sx={{pb:2}}>{t("product_variation_list.instruction_no_1")}</Typography>
                    </Box>
                }
            </Popover>
            <Container>
                <Grid container spacing={0}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <HeaderTitle title={t("product_variation_list.product_variations")} />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6} className="product_list_inst_icon" >
                        {!isDemoUser && <Box component="span">
                            <Typography className="about_uploading_image">{t("product_variation_list.about_variation_settings")}
                                <InfoRoundedIcon                                         
                                    onClick={handleInsPopoverOpen} 
                                    color="primary" 
                                    className="image_upload_instruction_icon"/>
                            </Typography>
                        </Box>} 
                    </Grid>
                </Grid>
            </Container>
            <Container>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <TextField
                            label={t("product_variation_list.search_place_holder")}
                            onChange={handleSearchChange}
                            // onKeyUp={handleKeyPress}
                            value={search}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {
                                            search && 
                                            <IconButton onClick={()=> setSearch("")}>
                                                <CloseIcon/>
                                            </IconButton>
                                        }
                                        <SearchIconButton
                                            setIsSearchChange={setIsSearchChange}
                                            apiCallFunction={productVariationListApi}
                                            page={currentPage}
                                            limit={limit}
                                        />
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined"
                            fullWidth
                            size="small"
                        />
                    </Grid>
                    <Grid item sm={1} md={5} lg={7}>
                    </Grid>
                    <Grid item xs={12} sm={5} md={3} lg={2} ref={node}>
                        <CommonButton route={window.location.pathname} functionToExecute={navigateToAddVariation} sx={{minWidth: { md: "90%" },textTransform: "capitalize"}} className="margin_download_button float_right" btnName={t("product_variation_list.add_new_variation")} />                       
                    </Grid>
                </Grid>
            </Container>
            <Container>
                <Grid container sx={{mt:4}}>
                    <Grid container >
                        <Container sx={{overflowX:"hidden"}}>
                            <Grid container my={2} p={2} className="word_wrap_class" alignItems={"center"}>
                                <Grid  item xs={12} sm={12} md={0.5} lg={0.5}>
                                    <Typography className="main_grid_data">{t("product_variation_list.sno")} </Typography>
                                </Grid>
                                <Grid  item xs={12} sm={12} md={1} lg={1}>
                                    <Typography className="main_grid_data">{t("product_variation_list.featured_image")} </Typography>
                                </Grid>
                                <Grid container xs={12} sm={12} md={1.2} lg={1.15} alignItems={"center"}>
                                    <Typography className="main_grid_data">{t("product_variation_list.product_code")} </Typography>
                                    <IconButton color="primary" size="small" onClick={()=>handleSorting(t("shukkamoto_mng_hinban"))} >
                                        {colFilter!="shukkamoto_mng_hinban" ? <SwapVertIcon className="swapVertIcon"/> : direction == "asc" ?<ArrowUpwardIcon className="sortingIconPosition"/>:<ArrowDownwardIcon className="sortingIconPosition"/> }
                                    </IconButton>        
                                </Grid>
                                <Grid container xs={12} sm={12} md={1.5} lg={1.5} alignItems={"center"}>
                                    <Typography className="main_grid_data">{t("product_variation_list.cainz_product_code")} </Typography>
                                    <IconButton color="primary" size="small" onClick={()=>handleSorting(t("daihyo_jan_cd"))} >
                                        {colFilter!="daihyo_jan_cd" ? <SwapVertIcon className="swapVertIcon" /> : direction == "asc" ?<ArrowUpwardIcon className="sortingIconPosition"/>:<ArrowDownwardIcon className="sortingIconPosition"/> }
                                    </IconButton>
                                </Grid>
                                <Grid container xs={12} sm={12} md={2.8} lg={2.75} alignItems={"center"}>
                                    <Typography className="main_grid_data">{t("product_variation_list.product_name")}</Typography>
                                    <IconButton color="primary" size="small" onClick={()=>handleSorting(t("prd_nm_kj"))} >
                                        {colFilter!="prd_nm_kj" ? <SwapVertIcon className="swapVertIcon"/> : direction == "asc" ?<ArrowUpwardIcon className="sortingIconPosition"/>:<ArrowDownwardIcon className="sortingIconPosition"/> }
                                    </IconButton>                   
                                </Grid>
                                <Grid  item xs={12} sm={12} md={1} lg={1}>
                                    <Typography className="main_grid_data">{t("product_variation_list.public_flag")} </Typography>
                                </Grid>
                                <Grid  item xs={12} sm={12} md={1.5} lg={1.5}>
                                    <Typography className="main_grid_data">{t("product_variation_list.variation_count")} </Typography>
                                </Grid>                                
                                <Grid container xs={12} sm={12} md={1.5} lg={1.5} alignItems={"center"}>
                                    <Typography className="main_grid_data">{t("product_variation_list.last_modified_date")} </Typography>
                                    <IconButton color="primary" size="small" onClick={()=>handleSorting(t("last_modified_date"))} >
                                        {colFilter!="last_modified_date" ? <SwapVertIcon className="swapVertIcon"/> : direction == "asc" ?<ArrowUpwardIcon className="sortingIconPosition"/>:<ArrowDownwardIcon className="sortingIconPosition"/> }
                                    </IconButton>                   
                                </Grid>                                
                                <Grid  item xs={12} sm={12} md={1} lg={1}>
                                    <Typography className="main_grid_data">{t("product_variation_list.action")} </Typography>
                                </Grid>  
                            </Grid>
                            {
                                skeleton ? (
                                    <Skeleton
                                        variant="rectangular"
                                        width="100%"
                                        height={60}
                                        count={5}
                                        my={1}
                                    />
                                ) : (
                                    variationData && variationData.length > 0 ?(
                                        variationData.map((faceProduct, index: number) => {
                                            const filteredVariationData = filterVariationDetails(variationDetailData,faceProduct);
                                    
                                            return(
                                                <>
                                                    <Accordion
                                                        key={index}
                                                        expanded={expandedIndex === index}
                                                        sx={{borderBottom:"2px solid #E0E0E0"}}
                                                        disabled={false}
                                                    >
                                                        <AccordionSummary 
                                                            expandIcon={<IconButton disabled={faceProduct.variationCount <=1}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleAccordionChange(index, variationData[index]?.variationGroupId)(e, expandedIndex !== index);
                                                                    showVariationDetails(variationData[index]?.variationGroupId, index);
                                                                }}

                                                            ><ExpandMoreIcon /></IconButton>}
                                                            onClick={ (e) =>{
                                                                e.stopPropagation();                                                            }
                                                            }
                                                            sx={{userSelect: "text",cursor:"default !important"}}                                                           
                                                        >
                                                            <FaceProductAccordion index={index} faceProduct={faceProduct} variationGroupId={variationData[index]?.variationGroupId} currentPage={currentPage} limit={limit} />
                                                        </AccordionSummary>
                                                        <AccordionDetails sx={{padding: "8px 12px 8px"}}>
                                                    
                                                            <NonFaceProducts  variationDetailData={filteredVariationData} index={index} nonFaceProductSkeleton={nonFaceProductSkeletonS[variationData[index]?.variationGroupId]}/>                                                     
                                                        </AccordionDetails>
                                                    </Accordion>                                           
                                                </>
                                            );
                                        })):
                                        <Box sx={{backgroundColor:"#F5F5F5" }}>
                                            <Typography  align="center" variant="body2">{t("product_variation_list.no_data_found")}</Typography>
                                        </Box>
                                        
                                )
                            }

                        </Container>
                    </Grid>
                </Grid>
                <Pagination
                    totalCount={totalCount}
                    currentPage={currentPage}
                    pageChange={productVariationListApi}
                    totalPage={totalPages}
                    rowsPerPage={limit}
                    rowsPerPageChange={setLimit}
                />
            </Container>
        </>
    );
};
export default ProductVariationList;


